import { getSafeRedirectPath } from '@/shared/lib/routes/safe-redirect';

/**
 * Nav hrefs that an unread announcement deep-links into. `/` only matches
 * itself — otherwise Home would light up for every announcement.
 */
export function railTargetsFor(
  navHrefs: readonly string[],
  redirects: readonly (string | null)[]
): Set<string> {
  const paths = redirects
    .map((r) => getSafeRedirectPath(r))
    .filter((p): p is string => p !== null)
    .map((p) => p.split(/[?#]/)[0] ?? p);
  const targets = new Set<string>();
  for (const href of navHrefs) {
    const hit = paths.some((p) =>
      href === '/' ? p === '/' : p === href || p.startsWith(`${href}/`)
    );
    if (hit) targets.add(href);
  }
  return targets;
}
